enum OrderDelayStatus {
  UncompletedWithoutDelay = 1,
  UncompletedWithDelay = 2,
  CompletedWithoutDelay = 3,
  CompletedWithDelay = 4
}

export default OrderDelayStatus;
